import { InviteMemberModalState } from '@adsk/acs-admin-ui-components-shared-components';

export const ACTIONS = {
  ...InviteMemberModalState.ACTIONS,
  ADD_NEWLY_CREATED_PROJECT_COMPANIES: 'addNewlyCreatedProjectCompanies',
  SET_PRODUCTS_ACCESSES: 'setProductsAccesses',
};
